var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",attrs:{"disabled":_vm.inProgress}},[(_vm.inProgress)?_c('i',{staticClass:"far fa-spinner fa-spin fa-fw",style:({ width: _vm.width })}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }